var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.5C4.88 1.5 6 2.62 6 4C6 5.38 4.61 6.2225 4.61 6.2225M4.61 6.2225L4.61 5.0925M4.61 6.2225L5.86 6.2225M3.5 6.5C2.12 6.5 1 5.39 1 4C1 2.3325 2.39 1.5 2.39 1.5M2.39 1.5L1.14 1.5M2.39 1.5L2.39 2.61",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 5.58016L1.33203 9.8335H8.66536C9.3987 9.8335 9.9987 9.2335 9.9987 8.50016L9.9987 1.8335L5.09204 1.8335",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 9.8335V11.8335C14.6654 12.9402 13.772 13.8335 12.6654 13.8335H11.9987C11.9987 13.1002 11.3987 12.5002 10.6654 12.5002C9.93203 12.5002 9.33203 13.1002 9.33203 13.8335L6.66536 13.8335C6.66536 13.1002 6.06536 12.5002 5.33203 12.5002C4.5987 12.5002 3.9987 13.1002 3.9987 13.8335H3.33203C2.22536 13.8335 1.33203 12.9402 1.33203 11.8335L1.33203 9.8335H8.66536C9.3987 9.8335 9.9987 9.2335 9.9987 8.50016V3.8335L11.2254 3.8335C11.7054 3.8335 12.1454 4.0935 12.3854 4.50684L13.5253 6.50016H12.6654C12.2987 6.50016 11.9987 6.80016 11.9987 7.16683V9.16683C11.9987 9.5335 12.2987 9.8335 12.6654 9.8335H14.6654Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 15.1667C6.06971 15.1667 6.66667 14.5697 6.66667 13.8333C6.66667 13.097 6.06971 12.5 5.33333 12.5C4.59695 12.5 4 13.097 4 13.8333C4 14.5697 4.59695 15.1667 5.33333 15.1667Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 15.1667C11.4017 15.1667 11.9987 14.5697 11.9987 13.8333C11.9987 13.097 11.4017 12.5 10.6654 12.5C9.92898 12.5 9.33203 13.097 9.33203 13.8333C9.33203 14.5697 9.92898 15.1667 10.6654 15.1667Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8.5V9.83333H12.6667C12.3 9.83333 12 9.53333 12 9.16667V7.16667C12 6.8 12.3 6.5 12.6667 6.5H13.5267L14.6667 8.5Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRto);
export default __webpack_public_path__ + "static/media/RTO.61c2ace920189a62b22457125864dfb7.svg";
export { ForwardRef as ReactComponent };